import React, { useState, useEffect } from 'react';

// Note: Although it is a React component, we use it as a function/maker
/* eslint-disable react/prop-types */
export const makeProvider =
  (Context) =>
    ({ value: valueProp, children }) => {
      const [value, setValue] = useState(valueProp ?? null);

      useEffect(() => {
        setValue(valueProp);
      }, [valueProp]);

      return <Context.Provider value={[value, setValue]}>{children}</Context.Provider>;
    };
